export const barCornerRadius = { top: 2, bottom: 2 };

export const NO_DATA_VALUE = null;
